import {
  clearFormDraft,
  getFormDraft,
  setFormDraft,
} from "@/lib/formPersistence/formDraftStorage";

export type TicketReplyDraft = {
  bodyHtml: string;
  toRecipients?: string;
  ccRecipients?: string;
  internalNoteText?: string;
  composeMode?: "reply" | "forward" | "internal";
};

export const ticketReplyDraftStorageKey = (
  memberId: string | number,
  ticketId: string | number,
) => `ticket-reply:${memberId}:${ticketId}`;

export const getTicketReplyDraft = (
  memberId: string | number,
  ticketId: string | number,
): TicketReplyDraft | null => {
  const draft = getFormDraft<TicketReplyDraft>(
    ticketReplyDraftStorageKey(memberId, ticketId),
  );
  if (!draft || typeof draft.bodyHtml !== "string") return null;
  return draft;
};

export const setTicketReplyDraft = (
  memberId: string | number,
  ticketId: string | number,
  draft: TicketReplyDraft,
) => {
  setFormDraft(ticketReplyDraftStorageKey(memberId, ticketId), draft);
};

export const clearTicketReplyDraft = (
  memberId: string | number,
  ticketId: string | number,
) => {
  clearFormDraft(ticketReplyDraftStorageKey(memberId, ticketId));
};
